export default __webpack_public_path__ + "static/media/LAA-logo.a5428d48.jpg";